<template>
	<div>
		<div class="table_head">
			<div class="flex flex_between">
				<div>
					<md-button class="md-blank" @click="uploadReceivables">
						<i class="fa fa-upload btn_icon" aria-hidden="true"></i>
						{{ $t("seller.sell.uploadReceivables") }}
					</md-button>
				</div>
			</div>
		</div>
		<div class="flex">
			<div class="flex flex_column w_100">
				<AgItem
					:rowData="rowData"
					:columnDefs="columnDefs"
					v-on:sortChanged="sortChanged"
					:with-tabs="true"
					:with-header="true"
				></AgItem>
				<Pagination
					:totalNum="totalNum"
					:pageSize="pageSize"
					:sizeChange="sizeChange"
					:currentChange="currentChange"
					:currentPage="page"
				></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import {asDecimal, asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import Pagination from "@/components/templates/common/Pagination";
import PaginationParent from "@/components/templates/common/PaginationParent";
import {revolvingPutOptionsSellerApi} from "@/common/api/revolvingPutOptionsSellerApi";
import {enumDef} from "@/common/enumDefs";
import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	extends: PaginationParent,
	components: { AgItem, Pagination },
	data() {
		return {
			rowData: [],
			columnDefs: [],
			sorting: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
		this.getList();
	},
	methods: {
		sortChanged(sortData) {
			this.sorting = sortData;
			this.initPage();
			this.getList();
		},
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.status"),
					field: "status",
					minWidth: 100,
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.revolvingPutOptionStatus,
					sortable: true,
				},
				{
					headerName: this.$t("common.debtor"),
					field: "debtorName",
					minWidth: 180,
					nameType: "debtorName",
					idType: "debtorId",
					cellRendererFramework: "CompanyTem",
					sortable: true,
				},
				{
					headerName: this.$t("common.investor"),
					field: "ownerCompanyName",
					minWidth: 180,
					nameType: "ownerCompanyName",
					idType: "ownerCompanyId",
					cellRendererFramework: "CompanyTem",
					sortable: true,
				},
				{
					headerName: this.$t("common.contractNumber"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.contractNumber.tooltip"),
					},
					field: "referenceNumber",
					minWidth: 175,
					cellRendererFramework: "RevolvingPutOptionReferenceRenderer",
					cellRendererParams: {
						soldReceivablesFunc: (data, postData) => revolvingPutOptionsSellerApi.inspection.listReceivables(data.id, postData)
					},
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.optionStart"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.optionStart.tooltip"),
					},
					field: "startDate",
					minWidth: 120,
					valueFormatter: asLocalizedDate(),
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.optionEnd"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.optionEnd.tooltip"),
					},
					field: "endDate",
					minWidth: 120,
					valueFormatter: asLocalizedDate(),
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.discount"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.discount.tooltip"),
					},
					headerClass: "align-right",
					field: "discountRate",
					cellStyle: {'justify-content': 'flex-end'},
					minWidth: 150,
					valueFormatter: asDecimal({ showPercentSign: true }),
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.premium"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.premium.tooltip"),
					},
					headerClass: "align-right",
					field: "premium",
					cellStyle: {'justify-content': 'flex-end'},
					minWidth: 150,
					valueFormatter: asDecimal({ showPercentSign: true }),
					sortable: true
				},
				{
					headerName: this.$t("common.currency"),
					field: "currency",
					minWidth: 100,
					maxWidth: 100,
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.revolvingLine"),
					headerComponentParams: {
						tooltip: this.$t("revolvingPutOption.table.header.revolvingLine.tooltip"),
					},
					headerClass: "align-right",
					field: "saleLimit",
					cellStyle: {'justify-content': 'flex-end'},
					minWidth: 120,
					valueFormatter: asDecimal(),
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.unusedSaleLimit"),
					headerClass: "align-right",
					field: "unusedSaleLimitAmount",
					cellStyle: {'justify-content': 'flex-end'},
					minWidth: 150,
					valueFormatter: asMoneyAmount(),
					sortable: true
				},
			];
		},
		getList() {
			let postData = {
				columns: [],
				filters: [],
				maxResults: this.maxResults,
				offset: this.offset,
				sorting: this.sorting
			};

			revolvingPutOptionsSellerApi.inspection.listActive(postData)
				.then(res => {
					this.setTotalNum(res.recordsTotal);
					this.rowData = res.data;
				})
				.catch(this.toast);
		},
		dataChanged() {
			this.$emit("changed");
		},
		uploadReceivables() {
			this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.upload, navigationTabs.seller.upload.upload));
		},
	}
};
</script>
